/* This JS modifies the layout of the homepage */

export function ReturnUser() {
	returnUserInit();
}

let $ = window.jQuery;

function returnUserInit() {
	hpAdjustments();
}

function hpAdjustments() {
	if ( 'true' === readCookie( 'jdrf_uv_home' ) && $( 'body' ).hasClass( 'home' ) ) {

		// Add Class to <body> to let us know that this is a return user
		$( 'body' ).addClass( 'bsd-return' );

		// Homepage Hero Changes
		$( '.bsd-hero__image' ).hide();
		$( '.bsd-hero__body' ).find( '.spirit-col-md-7' ).addClass( 'spirit-col-md-8' ).removeClass( 'spirit-col-md-7' );

		// Hide Sign-up CTA
		$( '.bsd-cta--sign-up-1' ).hide();

		// Move Latest under hero
		$( '.bsd-latest' ).insertAfter( $( '.bsd-hero' ) );

		// Update spacing between Latest and Touts
		$( '.bsd-latest .spirit-container__inner--padding-bottom-m' ).addClass( 'spirit-container__inner--padding-bottom-s' ).removeClass( 'spirit-container__inner--padding-bottom-m' );
		$( '.bsd-touts > .spirit-container .spirit-container__inner--padding-top-m' ).addClass( 'spirit-container__inner--padding-top-s' ).removeClass( 'spirit-container__inner--padding-top-m' );


	}
}

function readCookie( name ) {
	var nameEQ = name + '=';
	var ca = document.cookie.split( ';' );
	for ( var i = 0; i < ca.length; i++ ) {
		var c = ca[i];
		while ( ' ' == c.charAt( 0 ) ) c = c.substring( 1, c.length );
		if ( 0 == c.indexOf( nameEQ ) ) return c.substring( nameEQ.length, c.length );
	}
	return null;
}

